import React, { useState } from 'react';
import { Input } from 'reactstrap';
import { Label } from 'reactstrap';
import { FormGroup } from 'reactstrap';
import styled from 'styled-components';

const SliderWithInput = ({
    label,
    unit,
    value,
    setValue
}: {
    label: string;
    unit?: string;
    value: string;
    setValue: (value: string) => void;
}) => {
    // Handle slider change
    const handleSliderChange = (event) => {
        setValue(event.target.value);
    };

    // Handle input change, with validation to ensure it's between 0 and 100
    const handleInputChange = (event) => {
        let newValue = event.target.value;

        // Ensure the value is within 0 - 100
        if (newValue < 0) {
            newValue = 0;
        } else if (newValue > 100) {
            newValue = 100;
        }

        setValue(newValue);
    };

    return (
        <FormGroup>
            <Label>{label}</Label>
            {/* Slider Input */}
            <Input
                type="range"
                min="0"
                max="100"
                value={value}
                onChange={handleSliderChange}
                style={{ marginBottom: '10px', width: '100%' }}
            />

            {/* Number Input */}
            <FlexContainer>
                <Input
                    type="number"
                    min="0"
                    max="100"
                    value={value}
                    onChange={handleInputChange}
                    style={{ width: '50px', textAlign: 'center' }}
                />
                <Label>{unit}</Label>
            </FlexContainer>
        </FormGroup>
    );
};

export default SliderWithInput;

const FlexContainer = styled.div`
    display: flex;
    align-items: baseline;
    gap: 2px;
`;
